import { MenuAction } from '../../components/common/Menu';
import { useUIEventTracker } from '../../hooks/useUIEventTracker';
import { PaymentLink } from '../../types/PaymentLink';

export interface UsePaymentLinkActions {
  actions: MenuAction[];
}

export type PaymentLinkAction = 'edit' | 'share' | 'pause' | 'finish';

export function usePaymentLinkActions(
  context: string,
  omit?: PaymentLinkAction[]
): UsePaymentLinkActions {
  const trackEvent = useUIEventTracker(context);

  const availableActions: MenuAction[] = [
    {
      name: 'edit',
      label: 'Editar',
      cb: (_link: PaymentLink) => {
        trackEvent('edit_payment_link');
      },
    },
    {
      name: 'share',
      label: 'Compartir',
      cb: (_link: PaymentLink) => {
        trackEvent('share_payment_link');
      },
    },
    {
      name: 'pause',
      label: 'Pausar',
      cb: (_link: PaymentLink) => {
        trackEvent('pause_payment_link');
      },
    },
    {
      name: 'finish',
      label: 'Finalizar',
      cb: (_link: PaymentLink) => {
        trackEvent('finish_payment_link');
      },
    },
  ];

  const actions = omit
    ? availableActions.filter((action) => {
        return !omit.includes(action.name as PaymentLinkAction);
      })
    : availableActions;

  return { actions };
}
